export default __webpack_public_path__ + "static/media/131.7cf49b92.jpg";